import { FC, ReactNode } from 'react';
import { animated, useSpring } from '@react-spring/web';

interface FadeInProps {
    children: ReactNode;
    duration?: number;
}

export const FadeIn: FC<FadeInProps> = ({ children, duration = 300 }) => {
    const styles = useSpring({
        from: { opacity: 0 },
        to: { opacity: 1 },
        config: { duration },
    });
    //@ts-ignore
    return <animated.div style={styles}>{children}</animated.div>;
};
